import { Controller } from "@hotwired/stimulus"

// Sidebar navigation controller - updates active state based on current URL
//
// Usage:
//   <nav data-controller="sidebar-nav">
//     <a href="/admin/users" data-sidebar-nav-target="link" data-path="/admin/users">Users</a>
//   </nav>
//
export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.updateActiveState()

    // Listen for Turbo navigation events to update active state
    document.addEventListener("turbo:load", this.updateActiveState.bind(this))
    document.addEventListener("turbo:frame-load", this.updateActiveState.bind(this))
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.updateActiveState.bind(this))
    document.removeEventListener("turbo:frame-load", this.updateActiveState.bind(this))
  }

  updateActiveState() {
    const currentPath = window.location.pathname

    this.linkTargets.forEach(link => {
      const linkPath = link.dataset.path || link.getAttribute("href")
      const isActive = this.isPathActive(currentPath, linkPath)
      const wrapper = link.closest("[data-sidebar-nav-target='item']")

      if (wrapper) {
        const indicator = wrapper.querySelector("[data-sidebar-nav-target='indicator']")

        if (isActive) {
          link.classList.add("bg-white/5", "text-white")
          link.classList.remove("text-zinc-300")
          if (indicator) indicator.classList.remove("hidden")
        } else {
          link.classList.remove("bg-white/5", "text-white")
          link.classList.add("text-zinc-300")
          if (indicator) indicator.classList.add("hidden")
        }
      }
    })
  }

  isPathActive(currentPath, linkPath) {
    // Exact match for root paths
    if (linkPath === "/admin" || linkPath === "/admin/") {
      return currentPath === "/admin" || currentPath === "/admin/"
    }

    // For other paths, check if current path starts with link path
    return currentPath.startsWith(linkPath)
  }
}
